import axiosInstance from "src/common/axiosInstance";

const headers = (workspaceId) => ({
  headers: workspaceId ? { "X-Workspace-ID": workspaceId } : undefined,
});

export async function getLeadFields(workspaceId, { pipelineId, includeInactive = false } = {}) {
  if (!workspaceId) return [];

  const response = await axiosInstance.get(`/workspaces/${workspaceId}/lead-fields`, {
    ...headers(workspaceId),
    params: {
      pipeline_id: pipelineId || undefined,
      include_inactive: includeInactive ? 1 : undefined,
    },
  });

  return response.data?.data || [];
}

export async function getLeadSchema(workspaceId, pipelineId) {
  const response = await axiosInstance.get(`/workspaces/${workspaceId}/lead-fields/schema`, {
    ...headers(workspaceId), params: { pipeline_id: pipelineId || undefined },
  });
  return response.data.data;
}

export async function createLeadField(workspaceId, payload) {
  const response = await axiosInstance.post(
    `/workspaces/${workspaceId}/lead-fields`,
    payload,
    headers(workspaceId)
  );
  return response.data?.data || response.data;
}

export async function updateLeadField(workspaceId, fieldId, payload) {
  const response = await axiosInstance.put(
    `/workspaces/${workspaceId}/lead-fields/${fieldId}`,
    payload,
    headers(workspaceId)
  );
  return response.data?.data || response.data;
}

export async function archiveLeadField(workspaceId, fieldId) {
  return axiosInstance.delete(
    `/workspaces/${workspaceId}/lead-fields/${fieldId}`,
    headers(workspaceId)
  );
}

export async function reorderLeadFields(workspaceId, fieldIds) {
  return axiosInstance.put(
    `/workspaces/${workspaceId}/lead-fields/reorder`,
    { field_ids: fieldIds },
    headers(workspaceId)
  );
}

export async function exportLeads(workspaceId, params = {}) {
  return axiosInstance.get("/leads/export", {
    ...headers(workspaceId),
    params,
    responseType: "blob",
  });
}
